<p class="margin-bottom-16">Please enter your account details to log in</p>
<form #formEmailCheck="ngForm" id="enterEmail" name="formEmailCheck" *ngIf="!isUser" (submit)="handleSubmitEmailCheck(formEmailCheck.value, $event)" novalidate>
  <div class="row">
    <div class="col-sm-7">
      <div class="form-group">
        <input class="form-control" 
                [ngClass]="{ 'has-error' : email.invalid && email.dirty }"
                id="email" 
                name="email" 
                type="email"
                #email="ngModel"
                [pattern]="emailPattern"
                ngModel
                required
                appCheckEmpty>
        <label class="control-label" for="email">Email address</label>
        <i class="icon control-validation-state"></i>
        
        <p class="help-block text-danger" *ngIf="email?.errors?.pattern">Must be a valid email address</p>
        <p class="help-block text-danger" *ngIf="email.invalid && email.dirty && !email?.errors?.pattern">Please enter your email address</p>
        <p class="help-block text-danger" *ngIf="userNotFound">There does not seem to be any account registered under that email address. Please check the email for any errors.</p>
      </div>
    </div>

    <div class="col-sm-5">
      <button id="formEmailCheck-submit" type="submit" class="btn btn-accent btn-lg btn-block margin-right-0" [disabled]="formEmailCheck.invalid">
        <div class="loader-container-btn" *ngIf="showEmailLoader">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        <span *ngIf="!showEmailLoader">Confirm</span>
      </button>
    </div>
  </div>
</form>

<div *ngIf="isUser">
  <app-login *ngIf="visibleSection === 'login'"></app-login>
  <app-login-display 
    *ngIf="visibleSection === 'logged-in'"
    (userActive) = "userActive($event)">
  </app-login-display>
</div>